import { RoleRestricted, Roles } from "@app/user";
import { JSX, useContext } from "react";
import MegaMenuHeader from "./MegaMenuHeader";
import MegaMenuLink from "./MegaMenuLink";
import MenuItemEnum from "./menuItemEnum";
import { FeatureFlagContext, Features } from "@app/feature-flags";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
export default function OverviewsMenu(): JSX.Element {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Overviews" />
        <ul className="menu">
          <RoleRestricted allowedRoles={[Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER]}>
            <MegaMenuLink
              menuItem={MenuItemEnum.EnterpriseComplianceDashboard}
              faIcon="area-chart"
              to="/overviews/enterprise-compliance-dashboard"
              linkText="Enterprise Compliance Dashboard"
              onClick={(e) => { (e.target as HTMLElement).blur() }}
            />
          </RoleRestricted>
          {featureFlags.has(Features.NETWORK_BENCHMARKING) && (
            <RoleRestricted allowedRoles={[Roles.COMPETITIVE_INSIGHTS_USER]}>
              <MegaMenuLink
                menuItem={MenuItemEnum.CompetitiveInsightsDashboard}
                faIcon="area-chart"
                to="/overviews/competitive-insights-dashboard"
                linkText="Competitive Insights Dashboard"
                onClick={(e) => { (e.target as HTMLElement).blur() }}
              />
            </RoleRestricted>
          )}
        </ul>
      </li>
    </ul>
  );
}
